import { capitalize } from 'lodash';

import { parseJson } from 'src/lib/common';

export const prepareSampleTalkingPoints = (sampleTalkingPoints) =>
  sampleTalkingPoints
    ?.flat() // Flatten the array of arrays
    .map((talkingPoint) => ({
      talkingPoint: capitalize(talkingPoint.name),
      rating: talkingPoint.score,
    }));

export const prepareUser = ({ accounts, companyInformation, ...rest }) => {
  const user = {
    ...rest,
    companyInformation: parseJson(companyInformation),
  };

  user.customers = accounts
    ? accounts.edges.map((edge) => ({
        role: edge.role,
        isInvited: edge.isInvited,
        ...edge.node,
      }))
    : [];

  return user;
};
